export function decodePathParam(param?: string) {
  if (!param) {
    return '';
  }

  try {
    return decodeURIComponent(param).trim();
  } catch {
    return param.trim();
  }
}
